module.exports = __webpack_public_path__ + "static/3-e4d1f246a2bd40e5130f191dfb2ff2cd.jpg";